<i18n>
{
	"en": {
		"confirmOrderRemovalTrip": "Are you sure you want to remove the selected order from trip {tripNumber}?"
	},
	"no": {
		"confirmOrderRemovalTrip": "Er du sikker på at du vil fjerne den valgte oppdrag fra turen {tripNumber}?"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:hasHeader="false"
		icon="cog"
		iconType="bp"
		width="480px"
		@ok="$emit('confirm')"
		@close="$emit('close')"
	>
		{{$tc('confirmOrderRemovalTrip', {tripNumber: tripNumber})}}
	</t-dialog>
</template>

<script>
export default {
	name: 'ConfirmRemoveTripOrder',
	props: {
		isShown: Boolean,
		trip: Object
	},
	computed: {
		tripNumber() {
			return this.trip? this.trip.tripNumber : '';
		}
	},
};
</script>
